import { defineMessages } from '@/i18n'

/** Тексты общих контролов редактора: загрузка картинок и видео, промпты, разделы каталога. */
export const messages = defineMessages({
  ru: {
    noRights: 'Нет прав',

    // useBlockUploadCommit
    uploadRun:
      'Картинка загружена, но не сохранена: блок сейчас переписывает AI. ' +
      'Загрузите её ещё раз, когда AI закончит.',
    uploadDirty:
      'Картинка загружена, но не сохранена: в блоке есть несохранённые правки. ' +
      'Сохраните блок и загрузите картинку ещё раз.',
    uploadGone: 'Картинка загружена, но блока уже нет — сохранять её некуда.',
    uploadNoPlace:
      'Картинка загружена, но её места в блоке больше нет. ' +
      'Откройте блок и загрузите картинку ещё раз.',
    uploadFailed: 'Картинка загружена, но сохранить её не удалось.',
    uploadSaved: 'Картинка загружена и сохранена',

    // useFileUpload
    fileTooBig: (mb: number) =>
      `Файл слишком большой: можно загрузить до ${mb} МБ. Сожмите картинку или выберите другую.`,

    // CategoryPicker
    noCategories: 'Разделы каталога пока не заведены.',

    // ImagePromptField / ImagePromptPreview
    aiPrompt: 'Промпт для AI',
    promptPlaceholder: 'Плоская векторная иллюстрация…',
    addAiPrompt: 'Добавить промпт для AI',
    edit: 'Править',
    promptNotDrawn: 'Промпт для AI · картинка ещё не нарисована',
    clear: 'Очистить',

    // ImageUpload / ImageUploadEmptyState / ImageUploadFilled
    imageUploadLabel: 'Нажмите для загрузки изображения',
    imageFormats: 'PNG, JPG, WebP · до 5 МБ',
    imageFormatsWide: 'PNG, JPG, WebP · до 5 МБ · формат 16:9',
    replaceImage: 'Заменить картинку',
    removeImage: 'Удалить картинку',

    // SecondLangNote
    secondLangNote: 'Промпты второго языка рисуются после перевода курса',

    // UploadProgressBody
    uploadingPercent: (percent: number) => `Загружаю… ${percent}%`,

    // VideoPlayerPreview / VideoUpload
    videoPreview: 'Предпросмотр видео',
    videoProcessing: (percent: number) => `Видео обрабатывается… ${percent}%`,
    videoStatusLoading: 'Загружаю статус видео…',
    videoUploadLabel: 'Нажмите или перетащите видео',
    replaceVideo: 'Заменить видео',
    removeVideo: 'Удалить видео',
    videoFormats: 'MP4, WebM, MOV, AVI · до 500 МБ',
  },
  en: {
    noRights: 'No permission',

    uploadRun:
      'The image was uploaded but not saved: AI is rewriting this block right now. ' +
      'Upload it again once AI is done.',
    uploadDirty:
      'The image was uploaded but not saved: the block has unsaved changes. ' +
      'Save the block and upload the image again.',
    uploadGone: 'The image was uploaded, but the block no longer exists — nowhere to save it.',
    uploadNoPlace:
      'The image was uploaded, but its place in the block is gone. ' +
      'Open the block and upload the image again.',
    uploadFailed: 'The image was uploaded, but it couldn’t be saved.',
    uploadSaved: 'Image uploaded and saved',

    fileTooBig: (mb: number) =>
      `File is too large: the limit is ${mb} MB. Compress the image or choose another one.`,

    noCategories: 'No catalog sections yet.',

    aiPrompt: 'AI prompt',
    promptPlaceholder: 'Flat vector illustration…',
    addAiPrompt: 'Add AI prompt',
    edit: 'Edit',
    promptNotDrawn: 'AI prompt · image not generated yet',
    clear: 'Clear',

    imageUploadLabel: 'Click to upload an image',
    imageFormats: 'PNG, JPG, WebP · up to 5 MB',
    imageFormatsWide: 'PNG, JPG, WebP · up to 5 MB · 16:9',
    replaceImage: 'Replace image',
    removeImage: 'Remove image',

    secondLangNote:
      'Images for second-language prompts are generated after the course is translated',

    uploadingPercent: (percent: number) => `Uploading… ${percent}%`,

    videoPreview: 'Video preview',
    videoProcessing: (percent: number) => `Processing video… ${percent}%`,
    videoStatusLoading: 'Loading video status…',
    videoUploadLabel: 'Click or drag a video here',
    replaceVideo: 'Replace video',
    removeVideo: 'Remove video',
    videoFormats: 'MP4, WebM, MOV, AVI · up to 500 MB',
  },
})
